export const DASHBOARD_MASONRY_HANDLERS = {
  DASHBOARD_METRIC_DETAILS_EMPTY_STATE_PRIMARY_CTA:
    'dashboard_metric_details_empty_state_primary_cta',
  DASHBOARD_METRIC_DETAILS_EMPTY_STATE_SECONDARY_CTA:
    'dashboard_metric_details_empty_state_secondary_cta',
  DASHBOARD_METRIC_DETAILS_ADD_DATA_CTA:
    'dashboard_metric_details_add_data_cta',
};
